import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {useTranslation} from "react-i18next";
import {usePostOrganisationMutation} from '../../../../../Redux/Api/Organisations';
import { Hydra } from '../../../../../Utils/Hydra'
import BusyArea from '../../../../Shared/BusyArea'
import Button from '../../../../Shared/Form/Button'
import StatusPopups from '../../../../Shared/Form/StatusPopups'
import Form from '../../../../Shared/Form/Form'
import Input, { FailedRequirements } from '../../../../Shared/Form/Input'
import Title from '../../../../Shared/Title'
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

const OrganisationCreatePage = () => {

    const navigate = useNavigate()
    const { t, i18n } = useTranslation();

    const [ postOrganisation ] = usePostOrganisationMutation()

    const [ busy, setBusy ] = useState(false)
    const [ error, setError ] = useState('')
    const [submitted, setSubmitted] = useState(false);

    const submit = async (data: any) => {
        if(busy) return
        setSubmitted(true)
        if(FailedRequirements(data, 'name')) return setError(t("genericError") || "")

        setBusy(true)
        setError('')

        try {
            await postOrganisation(data).unwrap()

            window.location.replace(`/${i18n.language}/dashboard/admin/organisation/list`)
        } catch(e) {
            let err = e as Hydra.Error
            setError(err['hydra:description'])
            setBusy(false)
        }

        setTimeout(() => setBusy(false), 200)
    }

    return (
        <>
            <Title text={t('organisation:addOrganisation')} textNotBold/>
            <BusyArea busy={ busy }>
                <Form submit={ submit }>
                    <StatusPopups setText={ setError } type='error' text={ error } />
                    <Input
                        submitted={submitted ? true : false}
                        required
                        label={t('admin:name')}
                        id='name'/>
                    <Button icon={faPlus} iconright title={t('admin:addButton')}/>
                </Form>
            </BusyArea>
        </>
    )
}

export default OrganisationCreatePage
